var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 4.75615L11.5527 1.35273C11.1891 0.987644 10.6963 0.780762 10.1833 0.780762H1.93891C0.868471 0.784818 0 1.65697 0 2.73195V19.607C0 20.682 0.868471 21.5542 1.93891 21.5542H13.5724C14.6428 21.5542 15.5113 20.682 15.5113 19.607V6.13536C15.5113 5.62018 15.3053 5.12123 14.9417 4.75615ZM13.4148 5.97716H10.3409V2.89015L13.4148 5.97716ZM1.93891 19.607V2.73195H8.40195V6.95072C8.40195 7.49024 8.83416 7.92428 9.3714 7.92428H13.5724V19.607H1.93891Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8278 13.5719L9.34231 10.7591H10.4145L9.46246 15.2449H8.34102L7.74024 12.6877L7.15179 15.2449H6.03342L5.07835 10.7591H6.15358L6.66809 13.5719L7.28427 10.7591H8.20238L8.8278 13.5719Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 20.7694,
    fill: "white",
    transform: "translate(0 0.785645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.eea7fc762c708e260a41fbc28ce04ceb.svg";
export { ForwardRef as ReactComponent };